


































































































import { computed, defineComponent, PropType, toRefs, useContext } from '@nuxtjs/composition-api'

import useCarDescriptions from '@/composables/use-car-descriptions'
import useStoreLink from '@/composables/use-store-link'

import DateHourRange from '@/classes/DateHourRange'
import PricedCar from '@/classes/PricedCar'
import Store from '@/classes/Store'
import useI18n from '@/composables/use-i18n'
import dataLayer, { DataLayer } from '@/modules/data-layer'
import { tdCarStoreSlide } from '@/modules/ga4'
import useBreakpoint from '@/composables/use-breakpoint'

import { FeatureFlagKey } from '@/modules/growthbook/feature-flag'

export default defineComponent({
  props: {
    car: {
      type: Object as PropType<PricedCar | null>,
      default: null,
    },
    store: {
      type: Object as PropType<Store | null>,
      default: null,
    },
    active: {
      type: Boolean,
      default: false,
    },
    range: {
      type: Object as PropType<DateHourRange | null>,
      default: null,
    },
    skeleton: {
      type: Boolean,
      default: false,
    },
  },
  setup (props, { emit }) {
    const { match } = useBreakpoint()
    const isMobile = !match('lg')

    const { car, store } = toRefs(props)

    const brand = computed(() => car.value?.brand?.name ?? car.value?.brand)
    const model = computed(() => car.value?.model?.name ?? car.value?.model)
    const { descriptions, equipments, insurances } = useCarDescriptions(car)

    const formatNumber = new Intl.NumberFormat('en-US').format
    const price = computed(() => car.value?.price)
    const originalPrice = computed(() => car.value?.originalPrice)

    const storeLink = useStoreLink(store)

    /** 當 `store` 為 `nullish` 時意味著這是模糊搜尋的結果，並且只顯示部分詳情 */
    const isBrief = computed(() => !props.store)

    const { app: { localePath }, query } = useContext()
    const confirmLink = computed(() => {
      const path = car.value?.link
      if (!path) return
      return localePath({
        path,
        query: query.value,
      })
    })

    const clickDetail = () => {
      if (!car.value || !store.value) return

      if (confirmLink.value) window.open(confirmLink.value, '_blank')

      if (car.value && store.value) {
        dataLayer.selectItem({
          items: [DataLayer.GogooutCarToEcommerceItem(car.value, store.value)],
        })
      }

      emit('click', car.value)
    }

    // 車輛配備保險
    const equipmentInsuranceList = computed(() => {
      const list: Array<{
        name: string,
        status: 'light' | 'strong'
      }> = []

      if (equipments.value) {
        for (const eq of equipments.value) {
          list.push({
            name: eq,
            status: 'light',
          })
        }
      }

      if (insurances.value) {
        for (const insurance of insurances.value) {
          list.push({
            name: insurance.content,
            status: 'strong',
          })
        }
      }

      return list
    })

    const i18n = useI18n()
    const carImgAlt = computed(() => String(i18n.t('SEO.store.img.car', [store.value?.name, car.value?.brand?.name, car.value?.model?.name])))

    /**
     *
     * @param right 是否為向右滑動
     */
    const onCarouselSlide = (right: boolean) => {
      tdCarStoreSlide(right, `${car.value?.brand?.name} ${car.value?.model?.name}`)
    }

    return {
      isMobile,

      brand,
      model,
      descriptions,
      formatNumber,
      price,
      originalPrice,

      storeLink,
      confirmLink,
      isBrief,
      clickDetail,
      equipmentInsuranceList,

      carImgAlt,

      onCarouselSlide,

      FeatureFlagKey,
    }
  },
})
